import React      from 'react';
import Style      from './style.sass';
import Fetch      from './fetch';
import Input      from './input';
import Resources  from './resources';

export default class Postal extends React.Component {

  constructor(props) {

    super(props);

    this.state = {
      text: '',
      results: [],
      error: '',
    }
  }

  _onChangeText = e => {

    this.setState({
      text: e.target.value,
    })
  }

  onFormSubmit = async (e) => {
    e.preventDefault();
    console.log('submit');
    if (this.state.text) {
      const params = { code: this.state.text.replace(/-/g, '') };
      try {
        const fetch = await Fetch
          .get('/postal_code', { params })
          .then((response) => {
            if (response.data.status === 'success') {
              this.setState({ 
                results: response.data.result,
                error: '',
               });
            } else {
              this.setState({
                results: [], 
                error: [response.data.result],
              })
            }}
          );
      } catch (err) {
        console.log(err);
      }
    } else {
      this.setState({
        results: [],
        error: 'キーワードを入力してください。'
      })
    }
  }

  formReset = () => {
    this.setState({
      text: '',
      results: [],
      error: '',
    })
  }

  render() {

    return (
      <div className={Style.Postal}>
        <h1>郵便番号検索サービス</h1>
        <div className='c-info u-mt-15 u-fs-s'>
          <p>
            郵便番号から住所、住所から郵便番号を検索できます。
          </p>
          <p>
            郵便番号：7桁の半角数字、ハイフン省略可
          </p>
          <p>
            住所：都道府県省略可
          </p>
        </div>
        <Input label='' onSubmit={this.onFormSubmit} onChange={this._onChangeText} value={this.state.text} placeholder='郵便番号または住所を入力してください' />
        <div className='u-mt-15 u-ta-right'>
          <div className='c-btn-main' onClick={this.formReset}>リセット</div>
        </div>
        <div className={Style.Postal__results}>
          <Resources resources={this.state.results}/>
          <p className={Style.Postal__error}>{this.state.error}</p>
        </div>
      </div>
    );
  }
}

